<template>
  <div class="training-overview-info-comp">
    <div class="title">
      <progress-status-tag
        :start-time="training.start_datetime"
        :end-time="training.end_datetime"
        type="tag"
      ></progress-status-tag>
      {{ training.name }}
    </div>

    <div class="items">
      <div class="item">
        <div class="label">考试时间</div>
        <div class="value">{{ formatDate(training.start_datetime) }} ~ {{ formatDate(training.end_datetime) }}</div>
      </div>

      <div class="item">
        <div class="label">布置教室</div>
        <div class="value">{{ training.teacher_vo.teacher_name }}</div>
      </div>

      <div class="item clazz">
        <div class="label">布置班级</div>
        <div class="value">
          {{ clazzInfo.map((clazz) => clazz.note_name || clazz.name).join('、') }}
        </div>
      </div>
    </div>

    <div class="split-line"></div>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop } from 'kuaidong-component'
import { ITrainingListItem } from 'kuaidong-model'
import { DateWrapper } from 'kuaidong-lib'
import ProgressStatusTag from '@/views/special-skill/ProgressTag.vue'
import orderBy from 'lodash/orderBy'
@Component({
  components: {
    ProgressStatusTag,
  },
})
export default class TrainingOverviewInfo extends BaseComponent {
  @Prop({ type: Object, required: true })
  training!: ITrainingListItem

  @Prop({
    type: Function,
    default: (dt: string) => {
      return new DateWrapper(dt).showDateStrShort3
    },
  })
  format!: (dt: string) => {}

  get clazzInfo() {
    return orderBy(this.training.class_vo_list, ['grade_no', 'class_no'])
  }
  formatDate(dt: string) {
    return this.format(dt)
  }
}
</script>
<style lang="less">
.training-overview-info-comp {
  > .title {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: #0a1629;
    display: flex;
    > .progress-status-tag-comp {
      margin-right: 8px;
    }
  }
  > .items {
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    > .item {
      > .label {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #9da2a9;
      }
      > .value {
        margin-top: 12px;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #0a1629;
      }

      &.clazz {
        width: 330px;
      }
    }
  }

  > .split-line {
    width: 100%;
    height: 1px;
    background: #dcdde0;
    margin-top: 51px;
  }
}
</style>
